module.exports = "<img src=\"" + require("../../../resources/images/kotlin-logo.png") + "\"/>";


//////////////////
// WEBPACK FOOTER
// ./src/slides/02-overview/01.pug
// module id = 318
// module chunks = 1